unit View.Grade_Colunas.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewGrade_ColunasEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbgrade_descricoes_id: TLabel;
    edgrade_descricoes_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcadastro: TLabel;
    edcadastro: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientGrade_ColunasGet: TXDataWebClient;
    XDataClientGrade_ColunasDelete: TXDataWebClient;
    Grade_ColunasDataset: TXDataWebDataSet;
    Grade_ColunasDatasetid: TIntegerField;
    Grade_ColunasDatasetaliado_id: TIntegerField;
    Grade_ColunasDatasetdata_base_id: TIntegerField;
    Grade_ColunasDatasetgrade_descricoes_id: TIntegerField;
    Grade_ColunasDatasetnome: TStringField;
    Grade_ColunasDatasetcadastro: TDateTimeField;
    Grade_ColunasDatasetcodigo_interno: TIntegerField;
    Grade_ColunasDatasetexcluido: TBooleanField;
    Grade_ColunasDatasetinclusao: TDateTimeField;
    Grade_ColunasDatasetalteracao: TDateTimeField;
    Grade_ColunasDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientGrade_ColunasGetLoad(Response: TXDataClientResponse);
    procedure XDataClientGrade_ColunasDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientGrade_ColunasDeleteError(Error: TXDataClientError);
    procedure Grade_ColunasDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewGrade_ColunasEdit: TFViewGrade_ColunasEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGrade_ColunasEdit }

procedure TFViewGrade_ColunasEdit.btSaveClick(Sender: TObject);
begin
  if Grade_ColunasDataset.State in dsEditModes then
  begin
        Grade_ColunasDataset.Post;
    Grade_ColunasDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewGrade_ColunasEdit.btDeleteClick(Sender: TObject);
begin
  if Grade_ColunasDataset.State in dsEditModes then
    Grade_ColunasDataset.Post;
  XDataClientGrade_ColunasDelete.Delete(Grade_ColunasDataset.EntitySetName,
    TJSObject(Grade_ColunasDataset.CurrentData));
end;


class function TFViewGrade_ColunasEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewGrade_ColunasEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewGrade_ColunasEdit.InsertEntity;
begin
  Grade_ColunasDataset.Close;
  Grade_ColunasDataset.SetJsonData('{}');
  Grade_ColunasDataset.Open;
  Grade_ColunasDataset.Insert;
end;

class function TFViewGrade_ColunasEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGrade_ColunasEdit(AForm).FInserting := AInserting;
    TFViewGrade_ColunasEdit(AForm).FId := AId;
    TFViewGrade_ColunasEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewGrade_ColunasEdit(AForm).InsertEntity
    else
      TFViewGrade_ColunasEdit(AForm).LoadEntity;
    TFViewGrade_ColunasEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewGrade_ColunasEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewGrade_ColunasEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Grade_ColunasDataset.Connection.Model.DefaultSchema.FindEntityType(
      Grade_ColunasDataset.EntitySetName
    )
  );
  XDataClientGrade_ColunasGet.Get(Grade_ColunasDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewGrade_ColunasEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewGrade_ColunasEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGrade_ColunasEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewGrade_ColunasEdit.XDataClientGrade_ColunasGetLoad(Response: TXDataClientResponse);
begin
  Grade_ColunasDataset.Close;
  Grade_ColunasDataset.SetJsonData(Response.Result);
  Grade_ColunasDataset.Open;
  
  Grade_ColunasDataset.Edit;  
end;

procedure TFViewGrade_ColunasEdit.XDataClientGrade_ColunasDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewGrade_ColunasEdit.XDataClientGrade_ColunasDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewGrade_ColunasEdit.Grade_ColunasDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewGrade_ColunasEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewGrade_ColunasEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.grade_colunas.form.message');
  lbMessage := TLabel.Create('view.grade_colunas.form.message.label');
  btCloseMessage := TButton.Create('view.grade_colunas.form.message.button');
  btCancel := TButton.Create('view.grade_colunas.form.btBack');
  btSave := TButton.Create('view.grade_colunas.form.btSave');
  btDelete := TButton.Create('view.grade_colunas.form.btDelete');
  lbid := TLabel.Create('view.grade_colunas.form.lbid');
  edid := TDBEdit.Create('view.grade_colunas.form.edid');
  lbaliado_id := TLabel.Create('view.grade_colunas.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.grade_colunas.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.grade_colunas.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.grade_colunas.form.eddata_base_id');
  lbgrade_descricoes_id := TLabel.Create('view.grade_colunas.form.lbgrade_descricoes_id');
  edgrade_descricoes_id := TDBEdit.Create('view.grade_colunas.form.edgrade_descricoes_id');
  lbnome := TLabel.Create('view.grade_colunas.form.lbnome');
  ednome := TDBEdit.Create('view.grade_colunas.form.ednome');
  lbcadastro := TLabel.Create('view.grade_colunas.form.lbcadastro');
  edcadastro := TDBEdit.Create('view.grade_colunas.form.edcadastro');
  lbcodigo_interno := TLabel.Create('view.grade_colunas.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.grade_colunas.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.grade_colunas.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.grade_colunas.form.edexcluido');
  lbinclusao := TLabel.Create('view.grade_colunas.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.grade_colunas.form.edinclusao');
  lbalteracao := TLabel.Create('view.grade_colunas.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.grade_colunas.form.edalteracao');
  lbexclusao := TLabel.Create('view.grade_colunas.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.grade_colunas.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Grade_ColunasDataset := TXDataWebDataSet.Create(Self);
  Grade_ColunasDatasetid := TIntegerField.Create(Self);
  Grade_ColunasDatasetaliado_id := TIntegerField.Create(Self);
  Grade_ColunasDatasetdata_base_id := TIntegerField.Create(Self);
  Grade_ColunasDatasetgrade_descricoes_id := TIntegerField.Create(Self);
  Grade_ColunasDatasetnome := TStringField.Create(Self);
  Grade_ColunasDatasetcadastro := TDateTimeField.Create(Self);
  Grade_ColunasDatasetcodigo_interno := TIntegerField.Create(Self);
  Grade_ColunasDatasetexcluido := TBooleanField.Create(Self);
  Grade_ColunasDatasetinclusao := TDateTimeField.Create(Self);
  Grade_ColunasDatasetalteracao := TDateTimeField.Create(Self);
  Grade_ColunasDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientGrade_ColunasGet := TXDataWebClient.Create(Self);
  XDataClientGrade_ColunasDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbgrade_descricoes_id.BeforeLoadDFMValues;
  edgrade_descricoes_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcadastro.BeforeLoadDFMValues;
  edcadastro.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Grade_ColunasDataset.BeforeLoadDFMValues;
  Grade_ColunasDatasetid.BeforeLoadDFMValues;
  Grade_ColunasDatasetaliado_id.BeforeLoadDFMValues;
  Grade_ColunasDatasetdata_base_id.BeforeLoadDFMValues;
  Grade_ColunasDatasetgrade_descricoes_id.BeforeLoadDFMValues;
  Grade_ColunasDatasetnome.BeforeLoadDFMValues;
  Grade_ColunasDatasetcadastro.BeforeLoadDFMValues;
  Grade_ColunasDatasetcodigo_interno.BeforeLoadDFMValues;
  Grade_ColunasDatasetexcluido.BeforeLoadDFMValues;
  Grade_ColunasDatasetinclusao.BeforeLoadDFMValues;
  Grade_ColunasDatasetalteracao.BeforeLoadDFMValues;
  Grade_ColunasDatasetexclusao.BeforeLoadDFMValues;
  XDataClientGrade_ColunasGet.BeforeLoadDFMValues;
  XDataClientGrade_ColunasDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewGrade_ColunasEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 562;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 502;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 502;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 502;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbgrade_descricoes_id.SetParentComponent(Self);
    lbgrade_descricoes_id.Name := 'lbgrade_descricoes_id';
    lbgrade_descricoes_id.Left := 24;
    lbgrade_descricoes_id.Top := 273;
    lbgrade_descricoes_id.Width := 14;
    lbgrade_descricoes_id.Height := 13;
    lbgrade_descricoes_id.Caption := 'grade_descricoes_id:';
    lbgrade_descricoes_id.Transparent := True;
    edgrade_descricoes_id.SetParentComponent(Self);
    edgrade_descricoes_id.Name := 'edgrade_descricoes_id';
    edgrade_descricoes_id.Left := 221;
    edgrade_descricoes_id.Top := 270;
    edgrade_descricoes_id.Width := 200;
    edgrade_descricoes_id.Height := 21;
    edgrade_descricoes_id.Enabled := True;
    edgrade_descricoes_id.TabOrder := 9;
    edgrade_descricoes_id.Text := 'edgrade_descricoes_id';
    edgrade_descricoes_id.DataField := 'grade_descricoes_id';
    edgrade_descricoes_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 300;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 297;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 10;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcadastro.SetParentComponent(Self);
    lbcadastro.Name := 'lbcadastro';
    lbcadastro.Left := 24;
    lbcadastro.Top := 327;
    lbcadastro.Width := 14;
    lbcadastro.Height := 13;
    lbcadastro.Caption := 'cadastro:';
    lbcadastro.Transparent := True;
    edcadastro.SetParentComponent(Self);
    edcadastro.Name := 'edcadastro';
    edcadastro.Left := 221;
    edcadastro.Top := 324;
    edcadastro.Width := 200;
    edcadastro.Height := 21;
    edcadastro.Enabled := True;
    edcadastro.TabOrder := 11;
    edcadastro.Text := 'edcadastro';
    edcadastro.DataField := 'cadastro';
    edcadastro.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 354;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 351;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 12;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 381;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 378;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 13;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 408;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 405;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 14;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 435;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 432;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 15;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 462;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 459;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 16;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Grade_ColunasDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Grade_ColunasDataset.SetParentComponent(Self);
    Grade_ColunasDataset.Name := 'Grade_ColunasDataset';
    Grade_ColunasDataset.AfterApplyUpdates := Grade_ColunasDatasetAfterApplyUpdates;
    Grade_ColunasDataset.EntitySetName := 'Grade_Colunas';
    Grade_ColunasDataset.Connection := DMConnection.ApiConnection;
    Grade_ColunasDataset.Left := 176;
    Grade_ColunasDataset.Top := 8;
    Grade_ColunasDatasetid.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetid.Name := 'Grade_ColunasDatasetid';
    Grade_ColunasDatasetid.FieldName := 'id';
    Grade_ColunasDatasetid.Required := True;
    Grade_ColunasDatasetaliado_id.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetaliado_id.Name := 'Grade_ColunasDatasetaliado_id';
    Grade_ColunasDatasetaliado_id.FieldName := 'aliado_id';
    Grade_ColunasDatasetaliado_id.Required := True;
    Grade_ColunasDatasetdata_base_id.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetdata_base_id.Name := 'Grade_ColunasDatasetdata_base_id';
    Grade_ColunasDatasetdata_base_id.FieldName := 'data_base_id';
    Grade_ColunasDatasetdata_base_id.Required := True;
    Grade_ColunasDatasetgrade_descricoes_id.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetgrade_descricoes_id.Name := 'Grade_ColunasDatasetgrade_descricoes_id';
    Grade_ColunasDatasetgrade_descricoes_id.FieldName := 'grade_descricoes_id';
    Grade_ColunasDatasetgrade_descricoes_id.Required := True;
    Grade_ColunasDatasetnome.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetnome.Name := 'Grade_ColunasDatasetnome';
    Grade_ColunasDatasetnome.FieldName := 'nome';
    Grade_ColunasDatasetnome.Required := True;
    Grade_ColunasDatasetnome.Size := 255;
    Grade_ColunasDatasetcadastro.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetcadastro.Name := 'Grade_ColunasDatasetcadastro';
    Grade_ColunasDatasetcadastro.FieldName := 'cadastro';
    Grade_ColunasDatasetcadastro.Required := False;
    Grade_ColunasDatasetcodigo_interno.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetcodigo_interno.Name := 'Grade_ColunasDatasetcodigo_interno';
    Grade_ColunasDatasetcodigo_interno.FieldName := 'codigo_interno';
    Grade_ColunasDatasetcodigo_interno.Required := True;
    Grade_ColunasDatasetexcluido.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetexcluido.Name := 'Grade_ColunasDatasetexcluido';
    Grade_ColunasDatasetexcluido.FieldName := 'excluido';
    Grade_ColunasDatasetexcluido.Required := False;
    Grade_ColunasDatasetinclusao.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetinclusao.Name := 'Grade_ColunasDatasetinclusao';
    Grade_ColunasDatasetinclusao.FieldName := 'inclusao';
    Grade_ColunasDatasetinclusao.Required := False;
    Grade_ColunasDatasetalteracao.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetalteracao.Name := 'Grade_ColunasDatasetalteracao';
    Grade_ColunasDatasetalteracao.FieldName := 'alteracao';
    Grade_ColunasDatasetalteracao.Required := False;
    Grade_ColunasDatasetexclusao.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetexclusao.Name := 'Grade_ColunasDatasetexclusao';
    Grade_ColunasDatasetexclusao.FieldName := 'exclusao';
    Grade_ColunasDatasetexclusao.Required := False;
    XDataClientGrade_ColunasGet.SetParentComponent(Self);
    XDataClientGrade_ColunasGet.Name := 'XDataClientGrade_ColunasGet';
    XDataClientGrade_ColunasGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGrade_ColunasGet, Self, 'OnLoad', 'XDataClientGrade_ColunasGetLoad');
    XDataClientGrade_ColunasGet.Left := 64;
    XDataClientGrade_ColunasGet.Top := 8;
    XDataClientGrade_ColunasDelete.SetParentComponent(Self);
    XDataClientGrade_ColunasDelete.Name := 'XDataClientGrade_ColunasDelete';
    XDataClientGrade_ColunasDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientGrade_ColunasDelete, Self, 'OnLoad', 'XDataClientGrade_ColunasDeleteLoad');
    SetEvent(XDataClientGrade_ColunasDelete, Self, 'OnError', 'XDataClientGrade_ColunasDeleteError');
    XDataClientGrade_ColunasDelete.Left := 64;
    XDataClientGrade_ColunasDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbgrade_descricoes_id.AfterLoadDFMValues;
    edgrade_descricoes_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcadastro.AfterLoadDFMValues;
    edcadastro.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Grade_ColunasDataset.AfterLoadDFMValues;
    Grade_ColunasDatasetid.AfterLoadDFMValues;
    Grade_ColunasDatasetaliado_id.AfterLoadDFMValues;
    Grade_ColunasDatasetdata_base_id.AfterLoadDFMValues;
    Grade_ColunasDatasetgrade_descricoes_id.AfterLoadDFMValues;
    Grade_ColunasDatasetnome.AfterLoadDFMValues;
    Grade_ColunasDatasetcadastro.AfterLoadDFMValues;
    Grade_ColunasDatasetcodigo_interno.AfterLoadDFMValues;
    Grade_ColunasDatasetexcluido.AfterLoadDFMValues;
    Grade_ColunasDatasetinclusao.AfterLoadDFMValues;
    Grade_ColunasDatasetalteracao.AfterLoadDFMValues;
    Grade_ColunasDatasetexclusao.AfterLoadDFMValues;
    XDataClientGrade_ColunasGet.AfterLoadDFMValues;
    XDataClientGrade_ColunasDelete.AfterLoadDFMValues;
  end;
end;

end.
